import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardTitle,
  Typography,
} from '@one-thd/sui-atomic-components';
import { Heart } from '@one-thd/sui-icons';

export const EmptyMessagingB2C = () => (
  <div className="sui-flex sui-justify-center sui-mt-6">
    <Card>
      <span className="sui-text-brand sui-flex sui-justify-center">
        <Heart color="current" />
      </span>
      <div className="sui-flex sui-justify-center sui-text-center">
        <CardTitle header="You have no lists" />
      </div>
      <CardBody>
        <div className="sui-text-center">
          <Typography>Start adding and organizing your products in lists today</Typography>
        </div>
        <div className="sui-text-center">
          <Typography>Select the Heart icon to save to a list</Typography>
        </div>
      </CardBody>
      <CardActions position="center">
        <Button variant="secondary" href="/" fullWidth>Start Shopping</Button>
      </CardActions>
    </Card>
  </div>
);

EmptyMessagingB2C.displayName = 'UserListsEmptyMessagingB2C';

EmptyMessagingB2C.propTypes = {};

EmptyMessagingB2C.defaultProps = {};
